/* Compatibility for additions only. The original store owns navigation and purchasing. */
(() => {
  const root = document.querySelector('[data-psily-experience]');
  if (!root) return;
  const activeClass = 'psily-experience-visible';
  const observer = new IntersectionObserver(entries => {
    document.documentElement.classList.toggle(activeClass, entries[0].isIntersecting);
  }, { rootMargin: '-5% 0px -5% 0px' });
  observer.observe(root);
  window.addEventListener('pagehide', () => document.documentElement.classList.remove(activeClass));
  const header = document.querySelector('.site-header');
  if (header) new ResizeObserver(() => {
    root.style.setProperty('--psily-header-height', `${header.getBoundingClientRect().height}px`);
  }).observe(header);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-psily-try-remote]');
    if (!link || !window.psily?.ready) return;
    event.preventDefault();
    window.psily.setProgress(.79);
    window.psily.selectMode(0);
  });
})();
